const apiAccess = {
  apiAccess: {
    apiAccessTitle: 'API アクセス',
    apiAppContent: `Enlighten Systems API を使用すると、ソフトウェア開発者は、システムの発電データを読み取る外部アプリケーションを記述できます。これらのアプリケーションは、お客様の代理として API リクエストを行うため、お客様にユーザーIDの入力を求めることがあります。お客様のユーザーIDは%{user_id}です。`,
    showApp: 'API アクセスが可能なアプリケーションを表示する',
    isGrantedApp: "どのアプリケーションにも API アクセスを許可していません。",
    apiSystemContent:
      '外部アプリケーションがデータを取得できるのは、API アクセスを許可しているシステムのみです。これはシステムオーナーが管理します。閲覧可能なシステムがこのリストに表示されていない場合は、オーナーが API アクセスを許可しないことを選択しているためです。',
    showSystem: 'API アクセスが許可されたシステムを表示する',
    isGrantedSystem: "どのシステムにも API アクセスを許可していません。",
    revokeAccess: 'アクセスを取り消す'
  }
};

export default apiAccess;
